(() => {
  const selector = '.tiaro-slide-lazy[data-tiaro-src], .tiaro-slide-lazy[data-tiaro-srcset]';
  const mobile = window.matchMedia('(max-width: 749px)');
  const isWrongViewportImage = (image) =>
    (image.classList.contains('slideshow-image--desktop') && mobile.matches) ||
    (image.classList.contains('slideshow-image--mobile') && !mobile.matches);
  const hydrate = (image) => {
    if (isWrongViewportImage(image)) return;
    const source = image.dataset.tiaroSrc;
    const sourceSet = image.dataset.tiaroSrcset;
    if (sourceSet) {
      image.srcset = sourceSet;
      image.removeAttribute('data-tiaro-srcset');
    }
    if (source) {
      image.src = source;
      image.removeAttribute('data-tiaro-src');
    }
    image.classList.remove('tiaro-slide-lazy');
  };
  const nearViewport = (image) => {
    const rect = image.getBoundingClientRect();
    return rect.right >= -300 && rect.left <= window.innerWidth + 300;
  };
  const images = [...document.querySelectorAll(selector)];
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isWrongViewportImage(entry.target)) {
          hydrate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px 15%' });
    images.forEach((image) => observer.observe(image));
    mobile.addEventListener?.('change', () => {
      document.querySelectorAll(selector).forEach((image) => {
        if (nearViewport(image)) hydrate(image);
      });
    });
  } else {
    images.forEach(hydrate);
  }
})();
